import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export default Loadable({
  loader: () => import( /* webpackChunkName: "publish-modal" */'./PublishingOptionsModal').then(mod => mod.default),
  LoadingComponent: () => null
});